<script setup lang="ts">
const { t } = useI18n();
</script>

<template>
  <div class="w-1/2">
    <lxc-card body-class="!p-4">
      <lxc-information class="!p-0">
        <template #component>
          <lxc-info-sign>
            <i-lxc-help-circle
              width="1.25rem"
              height="1.25rem"
              view-box="0 0 1.25rem 1.25rem"
            />
          </lxc-info-sign>
        </template>
        <template #body>
          {{
            t(
              "campaign.funnel.campaignSettings.typeOfCampaign.configurationUpdate.selfSupporting.warningMessage",
            )
          }}
        </template>
      </lxc-information>
    </lxc-card>
  </div>
</template>
